<div class="modal-container">
  <div class="logo-container">
    <img src="../../../../../assets/img/logo-header.png" />
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()" class="form-fields">
    <input
      type="text"
      [class.is-invalid]="
        form.get('email').invalid && form.get('email').touched
      "
      class="form-control"
      formControlName="email"
      placeholder="{{ 'email' | translate }} *"
    />

    <ng-container *ngIf="isBr">
      <div class="name-row">
        <input
          type="text"
          [class.is-invalid]="
            form.get('firstName').invalid && form.get('firstName').touched
          "
          class="form-control"
          formControlName="firstName"
          placeholder="{{ 'name' | translate }}"
        />
        <input
          type="text"
          [class.is-invalid]="
            form.get('lastName').invalid && form.get('lastName').touched
          "
          class="form-control"
          formControlName="lastName"
          placeholder="{{ 'last-name' | translate }}"
        />
      </div>

      <input
        type="text"
        [class.is-invalid]="
          form.get('company').invalid && form.get('company').touched
        "
        class="form-control"
        formControlName="company"
        placeholder="{{ 'global.exclusiveModal.companyName' | translate }} *"
      />

      <select
        [class.is-invalid]="
          form.get('industry').invalid && form.get('industry').touched
        "
        class="form-control"
        formControlName="industry"
      >
        <option value="" disabled selected>
          {{ "global.exclusiveModal.industryPlaceholder" | translate }} *
        </option>
        <option *ngFor="let opt of industryOptions" [value]="opt.value">
          {{ opt.labelKey | translate }}
        </option>
      </select>

      <div class="phone-input-container">
        <ngx-intl-tel-input
          [cssClass]="
            'form-control' +
            (form.get('phone').invalid && form.get('phone').touched
              ? ' is-invalid'
              : '')
          "
          [preferredCountries]="preferredCountries"
          [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true"
          [customPlaceholder]="'global.newsForm.phone' | translate"
          [searchCountryFlag]="true"
          [searchCountryField]="[
            SearchCountryField.Name,
            SearchCountryField.DialCode
          ]"
          [selectFirstCountry]="true"
          [maxLength]="15"
          formControlName="phone"
        ></ngx-intl-tel-input>
        <div
          *ngIf="form.get('phone').invalid && form.get('phone').touched"
          class="phone-error-message"
        >
          {{ "global.newsForm.invalidPhone" | translate }}
        </div>
      </div>
    </ng-container>

    <div class="captcha-container">
      <img [src]="imgCaptcha" alt="captcha" class="captcha-image" />
      <a (click)="generateCaptcha()" class="reload-link">
        {{ "global.newsForm.reloadImg" | translate }}
      </a>
    </div>

    <input
      formControlName="inputCaptcha"
      class="form-control"
      placeholder="{{ 'global.newsForm.captchaPlaceholder' | translate }}"
      type="text"
    />

    <div>
      <label
        style="color: red; font-size: 12px;"
        *ngIf="errorCaptcha && form.controls.inputCaptcha.value == ''"
        >{{ "global.newsForm.verificationText" | translate }}</label
      >
      <label
        style="color: red; font-size: 12px;"
        *ngIf="
          errorCaptcha &&
          form.controls.inputCaptcha.value != '' &&
          form.controls.inputCaptcha.value != textCaptcha
        "
        >{{ "global.newsForm.verifyText" | translate }}</label
      >
    </div>

    <button
      mat-button
      color="warn"
      class="subscribe-btn"
      type="submit"
      [disabled]="form.invalid"
    >
      {{ "global.newsForm.subscribe" | translate }}
    </button>
  </form>
</div>
